import actiontypes from "../actions/actiontypes";
import { handleGetProviderWatcher, setLoginError } from "../actions/loginactioncreators";
import { put, takeLatest, select} from 'redux-saga/effects'
import * as queryString from 'query-string'
import { getProvider } from '../../lib/services'
import getLocale from "../helpers/getLocale";

export function* getProviderAsync(action) {
  try {
    const parsedQueryString = queryString.parse(window.location.search);
    let payload = action.payload;
    if (parsedQueryString.client_id) {
      payload.client_id = parsedQueryString.client_id
    }
    payload.username = payload.username.trim().toLowerCase();
    const locale = yield select(getLocale);
    const options = {
      headers: {
        'Accept-Language': locale,
      }
    };
    let { data } = yield getProvider(payload, options);
    if (data.provider.type === 'COGNITO') {
      yield put(handleGetProviderWatcher(data));
    } else {
      let location = '';
      if (parsedQueryString.state) {
        location = data.provider.url + '&state=' + parsedQueryString.state;
      } else {
        location = data.provider.url;
      }
      if(parsedQueryString.nonce) {
        location += '&nonce=' + parsedQueryString.nonce;
      }
      window.location = location;
    }
  } catch (e) {
    if (e.response) {
      if (e.response.data) {
        yield put(setLoginError([e.response.data.reasonMessage]))
      } else {
        yield put(setLoginError(['unknown error']))
      }
    } else if (e.request) {
      yield put(setLoginError(['unknown error']))
    }
  }
}

export function* watchGetProviderAsync() {
  yield takeLatest(actiontypes.USER_GET_PROVIDER, getProviderAsync);
}